import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=2bd7e364"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"
import style0 from "./home-page.vue?vue&type=style&index=0&id=2bd7e364&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports